// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-width[data-v-17f0d72f]{width:100%}.root__charging-option .sub-headline[data-v-17f0d72f]{display:none}.root__charging-option[sub-brand=usa] .sub-headline[data-v-17f0d72f]{display:block}", ""]);
// Exports
module.exports = exports;
